import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { ILeaveManagement, ILeaveManagementState } from './type';
import { RequestStatus } from '@app/constants';
import { IRequestFailed } from '@app/types';
const initialState: ILeaveManagementState = {
  addLeaveManagement: {},
  leaveManagement: {},
  updateLeaveManagementStatus: {},
  deleteLeaveManagement: {},
  updateLeaveManagement: {},
};
const slice = createSlice({
  name: 'leaveManagement',
  initialState,
  reducers: {
    addLeaveManagement(state, action: PayloadAction<ILeaveManagement>) {
      state.addLeaveManagement.status = RequestStatus.RUNNING;
    },
    addLeaveManagementSuccess(state, action: PayloadAction<ILeaveManagement>) {
      state.addLeaveManagement.status = RequestStatus.SUCCESS;
      state.addLeaveManagement.data = action.payload;
    },
    addLeaveManagementFailed(state, action: PayloadAction<IRequestFailed>) {
      state.addLeaveManagement.status = RequestStatus.ERROR;
      state.addLeaveManagement.error = action.payload;
    },
    //
    getLeaveManagement(state) {
      state.leaveManagement.status = RequestStatus.RUNNING;
    },
    getLeaveManagementSuccess(
      state,
      action: PayloadAction<ILeaveManagementState['leaveManagement']['data']>
    ) {
      state.leaveManagement.status = RequestStatus.SUCCESS;
      state.leaveManagement.data = action.payload;
    },
    getLeaveManagementFailed(state, action: PayloadAction<IRequestFailed>) {
      state.leaveManagement.status = RequestStatus.ERROR;
      state.leaveManagement.error = action.payload;
    },
    //
    updateLeaveManagementStatus(state, action: PayloadAction<any>) {
      state.updateLeaveManagementStatus.status = RequestStatus.RUNNING;
    },
    updateLeaveManagementStatusSuccess(state, action: PayloadAction<ILeaveManagement>) {
      state.updateLeaveManagementStatus.status = RequestStatus.SUCCESS;
      state.updateLeaveManagementStatus.data = action.payload;
    },
    updateLeaveManagementStatusFailed(state, action: PayloadAction<IRequestFailed>) {
      state.updateLeaveManagementStatus.status = RequestStatus.ERROR;
      state.updateLeaveManagementStatus.error = action.payload;
    },
    //
    deleteLeaveManagement(state, action: PayloadAction<{ id: number }>) {
      state.deleteLeaveManagement.status = RequestStatus.RUNNING;
    },
    deleteLeaveManagementSuccess(state, action: PayloadAction<ILeaveManagement>) {
      state.deleteLeaveManagement.status = RequestStatus.SUCCESS;
    },
    deleteLeaveManagementFailed(state, action: PayloadAction<IRequestFailed>) {
      state.deleteLeaveManagement.status = RequestStatus.ERROR;
      state.deleteLeaveManagement.error = action.payload;
    },
    //
    updateLeaveManagement(state, action: PayloadAction<ILeaveManagement>) {
      state.updateLeaveManagement.status = RequestStatus.RUNNING;
    },
    updateLeaveManagementSuccess(state, action: PayloadAction<ILeaveManagement>) {
      state.updateLeaveManagement.status = RequestStatus.SUCCESS;
      state.updateLeaveManagement.data = action.payload;
    },
    updateLeaveManagementFailed(state, action: PayloadAction<IRequestFailed>) {
      state.updateLeaveManagement.status = RequestStatus.ERROR;
      state.updateLeaveManagement.error = action.payload;
    },
    //
  },
});
export default slice.reducer;

export const {
  addLeaveManagement,
  addLeaveManagementSuccess,
  addLeaveManagementFailed,
  getLeaveManagement,
  getLeaveManagementFailed,
  getLeaveManagementSuccess,
  updateLeaveManagementStatus,
  updateLeaveManagementStatusSuccess,
  updateLeaveManagementStatusFailed,
  deleteLeaveManagement,
  deleteLeaveManagementFailed,
  deleteLeaveManagementSuccess,
  updateLeaveManagement,
  updateLeaveManagementFailed,
  updateLeaveManagementSuccess,
} = slice.actions;
